import {Observer} from "../LibrariesImport";
import {GlobalVariables} from "../GlobalVariables";

export default class Header {
	static init() {
		this.header = document.querySelector(".header-main");
		if (this.header) {
			this.navMain = this.header.querySelector(".navs");
			this.toggleHeader();
			this.resize();

		}
		GlobalVariables.resizeCallbacks.push(this);
	}

	static toggleHeader() {
		Observer.create({
			type: "scroll",
			tolerance: 30,
			dragMinimum: 30,
			onUp: () => {
				this.showHeader();
			},
			onDown: () => {
				this.hideHeader();
			},
		});

		if (window.innerWidth > 991) {
			setTimeout(() => {
				if (window.scrollY > 100) {
					this.hideHeader();
				}
			}, 0);
		}
	}

	static hideHeader() {
		this.header.classList.add("hide");
	}

	static showHeader() {
		this.header.classList.remove("hide");
	}

	static resize() {
		if (window.innerWidth > 991) {
			document.body.classList.remove("navs-open");
			GlobalVariables.smoother.paused( false );
		}
	}
}
